import { mergeStyles } from '@uifabric/merge-styles'
import React from 'react'
import { Button } from './button'

export const OptionSection = ({start, clear}: {start: Function, clear: Function}) => (
	<div className={mergeStyles({
		textAlign: 'center',
	})}>
		<Button name={'Clear'} action={clear} />
		<Button name={'Practice'} action={start} />
	</div>
)